'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _api = require('../api');

var Api = _interopRequireWildcard(_api);

var _search = require('../search');

var _search2 = _interopRequireDefault(_search);

var _config = require('../config');

var _constants = require('../constants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var search = (0, _search2.default)();
var Establishment = {
  search: search,
  createSearch: _search2.default,
  get: function get(id) {
    if (!id) {
      throw new Error('Establishment ID not provided');
    }
    if (Array.prototype.isPrototypeOf(id)) {
      return Api.getEstablishmentsRequest(id).then(function (resp) {
        return search.establishments.map(resp.data);
      });
    }

    return {
      description: function description() {
        var culture = (0, _config.getConfig)('DOMAIN_CULTURE');
        var intlFallback = _constants.CULTURE_FALLBACK[culture].split('-');
        var intl = culture.split('-');
        return Api.getDescriptionRequest(id).then(function (response) {
          return response.data;
        }).then(function (data) {
          return (data[intl[0]] && data[intl[0]][intl[1]] || data[intlFallback[0]] && data[intlFallback[0]][intlFallback[1]] || data.en && (data.en.us || data.en.gb) || { txt: '' }).txt;
        });
      },
      extraInfo: function extraInfo() {
        return Api.getExtraInfo(id).then(function (response) {
          return response.data;
        });
      },
      images: function images() {
        return Api.getImagesRequest(id).then(function (response) {
          return response.data;
        });
      }
    };
  }
};

exports.default = Establishment;